module.exports = __webpack_public_path__ + "static/media/mau.ff8efb4a.png";